import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const crmLookupService = {
  wonAnalysis,
  lostAnalysis,
}

/** Won revenue, real cost and profit, ranked by customer group. */
export function wonAnalysis(params = {}) {
  return apiHelper(API_URL).get('/crm/analysis/won', { params })
}

/** Why business was lost, as a share of the whole. */
export function lostAnalysis(params = {}) {
  return apiHelper(API_URL).get('/crm/analysis/lost', { params })
}
